export default {
  debug: false,
  base_utl: 'https://www.codenidus.com',
  api_url: 'https://www.codenidus.com/mail/',
  api_token_url: 'https://www.codenidus.com/mail/videoconference/token',
  webrtc_url: 'https://api.vidus.app',
  webrtc_connection: 'api.vidus.app',
  peer_secure: true,
  peer_host: 'peer.vidus.app',
  peer_port: '443',
  videoconference_theme: 'Canvasface',
  mediapipe: {
    models: {
      'faceDetector': 'https://www.codenidus.com/models/face',
      'bodySegmentation': 'https://www.codenidus.com/models/selfie'
    },
    fps: 30
  },
  axios: {
    headers: {}
  }
}
